import styled from 'styled-components';

import { config } from 'config';
const color = config.theme?.header?.color ? config.theme.header.color : '#aab2b8';

export const InfoWrapper = styled.div`
  display: flex;
  //flex-direction: column;
  //justify-content: space-between;
  margin: 0 auto;
  /* height: 168px; */
  box-sizing: border-box;
`;
export const Signals = styled.div`
  display: flex;
`;
export const Separator = styled.div`
  height: 1px;
  margin: 0 15px;
  background-color: #313335;
`;
export const InfoGroup = styled.div`
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  p {
    margin: 0 10px 0 0;
    /* color: ${color}; */
    color: #e6eaec;
    font-size: 13px;
    font-weight: 500;
  }
`;
export const CallsCount = styled.div`
  display: flex;
  align-items: center;
  color: #ff4747;
  img {
    margin-right: 4px;
  }
`;
// фон и тень счётчика сигналов по приоритету
const palette = {
  1: { bg: '#cc2936', hover: '#b3222f', shadow: '#8f1b25' },
  2: { bg: '#d4a017', hover: '#b88a12', shadow: '#8f6c0e' },
  3: { bg: '#e6d56d', hover: '#d2c158', shadow: '#a89a45' },
};
const pick = (props, key) => (palette[props.priority] || palette[1])[key];

export const Button = styled.button`
  height: 34px;
  line-height: 32px;
  min-width: 34px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: #e6eaec;
  border-radius: 10px;
  padding: 0 7px;
  border: 1px solid #3d4952;
  cursor: pointer;
  background: #141c18;
  margin: 0 0 0 10px;
  position: relative;
  transition:
    border-color 0.15s ease,
    background 0.15s ease,
    color 0.15s ease;
  &:hover {
    border-color: #47b972;
    color: #5cc98a;
    background: #1a2429;
  }
`;

// счётчик сигналов — расширение кнопки из libs/ui (размер, скругление, шрифт те же), отличается только цветом
export const SignalsCount = styled(Button)
  .withConfig({ shouldForwardProp: (prop) => prop !== 'priority' })
  .attrs({ size: 'medium', $square: true })`
  margin: 0 4px 0 0;
  background: ${(props) => pick(props, 'bg')};
  border-color: ${(props) => pick(props, 'bg')};
  &:hover {
    background: ${(props) => pick(props, 'hover')};
    border-color: #e6eaec;
    color: #e6eaec;
  }
`;
